const Reducer = (state = {}, { type, payload }) => {
  switch (type) {
    case "SAVE_Example":
      return { ...state, Example: payload };
    default:
      return state;
  }
};

export default Reducer;
